/** Polska strefa czasowa — daty w panelu traktujemy jako czas „na zegarze” w Warszawie. */
export const POLAND_TIMEZONE = 'Europe/Warsaw';

const DATETIME_LOCAL_RE = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/;

/** Offset strefy (w minutach) względem UTC w danym momencie — dodatni = strefa do przodu (np. +120). */
function getTimezoneOffsetMinutes(timeZone, date) {
  const utc = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const zoned = new Date(date.toLocaleString('en-US', { timeZone }));
  return (zoned.getTime() - utc.getTime()) / 60000;
}

/**
 * Wartość z <input type="datetime-local"> (np. 2026-05-20T14:00) jako godzina w Polsce → ISO UTC do bazy.
 */
export function warsawDatetimeLocalToIso(localValue) {
  if (!localValue || !String(localValue).trim()) return null;
  const trimmed = String(localValue).trim();
  const match = trimmed.match(DATETIME_LOCAL_RE);
  if (!match) {
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? trimmed : parsed.toISOString();
  }
  const [, y, mo, d, h, mi] = match.map((v, i) => (i === 0 ? v : Number(v)));
  const year = Number(y);
  const month = Number(mo);
  const day = Number(d);
  const hour = Number(h);
  const minute = Number(mi);
  const guessUtc = new Date(Date.UTC(year, month - 1, day, hour, minute));
  const offsetMin = getTimezoneOffsetMinutes(POLAND_TIMEZONE, guessUtc);
  return new Date(guessUtc.getTime() - offsetMin * 60 * 1000).toISOString();
}

/**
 * ISO z bazy (UTC) → wartość dla datetime-local w polskiej strefie.
 */
export function isoToWarsawDatetimeLocal(isoValue) {
  if (!isoValue) return '';
  const date = new Date(isoValue);
  if (Number.isNaN(date.getTime())) return '';
  const offsetMin = getTimezoneOffsetMinutes(POLAND_TIMEZONE, date);
  const warsaw = new Date(date.getTime() + offsetMin * 60 * 1000);
  const pad = (n) => String(n).padStart(2, '0');
  return `${warsaw.getUTCFullYear()}-${pad(warsaw.getUTCMonth() + 1)}-${pad(warsaw.getUTCDate())}T${pad(warsaw.getUTCHours())}:${pad(warsaw.getUTCMinutes())}`;
}

/** Lista / podgląd: data i godzina w Polsce. */
export function formatWarsawDateTime(isoValue) {
  if (!isoValue) return '';
  const date = new Date(isoValue);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('pl-PL', {
    timeZone: POLAND_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** start_date / end_date z formularza → do zapisu w Supabase. */
export function eventDatesToStorage(startLocal, endLocal) {
  return {
    start_date: warsawDatetimeLocalToIso(startLocal),
    end_date: endLocal ? warsawDatetimeLocalToIso(endLocal) : null,
  };
}
